import React, { useEffect, useState } from 'react';
import { Typography, CircularProgress, Card, CardContent, Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import Layout from '../components/Layout';
import { deleteCourse, getAllCourses, markCoursePublish, updateCourseStatus} from '../service/service'; // Import the service function
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [courseToDelete, setCourseToDelete] = useState(null);

  const navigate = useNavigate();

  const fetchCourses = async () => {
    setLoading(true); // Start loading
    try {
      const data = await getAllCourses(); // Call the service function
      setCourses(data.data); // Set courses in state
    } catch (error) {
      console.error("Failed to fetch courses:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };
  
  useEffect(() => {
    fetchCourses(); // Fetch courses when the component mounts
  }, []);

  const handleEdit = (id) => {
    navigate(`/edit/${id}`); // Navigate to edit page with course ID
  };

  const handleCreateCourse = () => {
    navigate(`/create-course`)
  }

  const handleCousePublish = async (courseId) => {
    const res = await markCoursePublish({ courseId })
    if (res.message) {
      alert("Course Published Successfully");
      fetchCourses()
    } else {
      alert("Something went wrong!!")
    }
  }

  const handleCourseStatusChange = async (courseId) => {
    const res = await updateCourseStatus({ courseId })
    if (res.message) {
      alert(res.message);
      fetchCourses()
    } else {
      alert("Something went wrong!!")
    }
  }

  // Open delete confirmation dialog
  const openDeleteDialog = (courseId) => {
    setCourseToDelete(courseId);
    setConfirmText('');
    setDeleteDialogOpen(true);
  };

  // Close delete confirmation dialog
  const closeDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setCourseToDelete(null);
    setConfirmText('');
  };

  // Handle text change in confirmation field
  const handleConfirmTextChange = (e) => {
    setConfirmText(e.target.value);
  };

  // Handle delete course action
  const handleDeleteCourse = async () => {
    if (confirmText.toLowerCase() !== 'delete') {
      alert('Please type "delete" to confirm');
      return;
    }

    try {
      const res = await deleteCourse({ courseId: courseToDelete });
      closeDeleteDialog();
      
      if (res.message) {
        alert(res.message);
        fetchCourses();
      } else {
        alert("Something went wrong while deleting the course!");
      }
    } catch (error) {
      console.error("Error deleting course:", error);
      alert("Failed to delete the course. Please try again.");
    }
  };

  return (
    <Layout>
      {loading ? ( // Show loading indicator
        <CircularProgress />
      ) : (
        <div>
          <div className='create-container'>
              <Button variant="contained" onClick={handleCreateCourse}>Create Course</Button>
          </div>
          <Grid container spacing={2}>
            {courses.map((course) => (
              <Grid item xs={12} sm={6} md={4} key={course._id}>
                <Card>
                  <CardContent>
                    <Typography variant="h5">{course.name}</Typography>
                    <Typography variant="body2">{course.description}</Typography>
                    <div className='course-action-button'>
                      <Button variant="contained" color="primary" onClick={() => handleEdit(course._id)} style={{ marginTop: '16px', marginRight: '8px' }}>
                        Edit
                      </Button>
                      {!course.isDraft && <Button variant="outlined" color="info" style={{ marginTop: '16px', marginRight: '8px' }} onClick={()=> handleCourseStatusChange(course._id)}>
                        {course.isDeleted ? 'Activate' : 'Deactivate'}
                      </Button>}
                      {course.isDraft && <Button variant="outlined" color="info" style={{ marginTop: '16px', marginRight: '8px' }} onClick={()=> handleCousePublish(course._id)}>
                        Publish
                      </Button>}
                      <Button variant="outlined" color="error" style={{ marginTop: '16px' }} onClick={() => openDeleteDialog(course._id)}>
                        Delete
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Delete Confirmation Dialog */}
          <Dialog open={deleteDialogOpen} onClose={closeDeleteDialog}>
            <DialogTitle>Delete Course</DialogTitle>
            <DialogContent>
              <Typography variant="body1" style={{ marginBottom: '16px' }}>
                Are you sure you want to delete this course? This action cannot be undone.
              </Typography>
              <Typography variant="body2" style={{ marginBottom: '16px' }}>
                To confirm, type "delete" in the field below:
              </Typography>
              <TextField
                autoFocus
                fullWidth
                value={confirmText}
                onChange={handleConfirmTextChange}
                placeholder="Type 'delete' to confirm"
                variant="outlined"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDeleteDialog} color="primary">
                Cancel
              </Button>
              <Button 
                onClick={handleDeleteCourse} 
                color="error" 
                variant="contained"
                disabled={confirmText.toLowerCase() !== 'delete'}
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </Layout>
  );
};

export default Dashboard;